// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import React, { RefObject } from 'react';

export type NavbarContextType = {
  navbarRef?: RefObject<HTMLElement | null>;
};

export const NavbarContext = React.createContext<NavbarContextType>({
  navbarRef: undefined,
});
